module.exports = __webpack_public_path__ + "img/icon-view-list.98b10102.svg";